export default __webpack_public_path__ + "static/media/arrow_back_ios-white-18dp.ace2da01.svg";